import styled, { CSSProperties } from 'styled-components';

interface VariantStarProps {
    style?: CSSProperties;
    className?: string;
}

export const VariantStar = (props: VariantStarProps) => {
    return (
        <S_VariantStar className={props.className} style={props.style}>
            <S_Image
                $src={
                    'https://dvtqxks0zalev.cloudfront.net/a231dfb4-9ede-43e5-925e-fe54514a0236.png'
                }
            />
        </S_VariantStar>
    );
};

const S_VariantStar = styled.div``;

const S_Image = styled.div<{ $src: string }>`
    background-image: url(${(props) => props.$src});
    background-size: cover;
    width: 20xp;
    height: 20px;
`;
